import { h, FunctionalComponent } from 'preact';
import { useContext, useEffect } from 'preact/hooks';
import { ApplicationContext } from 'contexts/use-application-setup';
import { layoutStore } from '../../../global/layout.store';

interface Props {}

export const NAGISHLI = 'nagishli';

export const NagishLiLogo: FunctionalComponent<Props> = () => {
  const { config, isNoFollowEnabled, whiteLabelOptions, customBrandingOptions } =
    useContext(ApplicationContext);

  const isHebrew =
    config.current && config.current.language && config.current.language.includes('he');
  const websiteName = isHebrew ? 'נגיש לי' : 'NagishLi';
  const logoSrc = isHebrew ? 'nagishli-he' : 'nagishli-en';
  const linkHref = isHebrew ? 'https://www.nagish.li/' : 'https://www.nagish.li/en';
  const itemClassName = isHebrew ? 'brand-footer__item-rtl' : 'brand-footer__item';

  useEffect(() => {
    if (
      config.current?.services?.partner !== NAGISHLI ||
      !!whiteLabelOptions?.wlHideLogo ||
      !!customBrandingOptions?.custom_logo_image_path
    )
      return;
    layoutStore.mainContainer.addClass('uw-partner');
  }, []);

  if (
    config.current?.services?.partner !== NAGISHLI ||
    !!whiteLabelOptions?.wlHideLogo ||
    !!customBrandingOptions?.custom_logo_image_path
  ) {
    return null;
  }

  return (
    <div className="brand-footer">
      <div className={itemClassName}>
        <a className="brand-footer-link" href={linkHref} target="_blank">
          <img
            height="33.32"
            src={`/frontend/images/${logoSrc}.png`}
            alt={`${websiteName} Logo - Opens in a new tab`}
          />
        </a>
      </div>
      <div className={itemClassName}>
        <a
          className="brand-footer-link"
          href="https://userway.org#uaw"
          target="_blank"
          {...(isNoFollowEnabled ? { rel: 'nofollow' } : {})}
        >
          <img
            height="33.32"
            src="/frontend/images/logo.svg"
            alt="UserWay Logo - Opens in a new tab"
          />
        </a>
      </div>
    </div>
  );
};
